import { createRouter, createWebHashHistory } from 'vue-router'
import { isLoginorNot } from '@/api'
import useHomeStore from '@/store/modules/home'
import { autoZykLogin } from '@/api/index'


const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/coursePreview',
    name: 'coursePreview',
    meta: {
      title: '课程观看'
    },
    component: () => import('@/components/studyNew'),
  },
  {
    path: '/home',
    component: () => import(/* webpackChunkName:"home" */ '@/views/home/routerView.vue'),
    redirect: '/home/index',
    children: [
      //首页
      {
        path: '/home/index',
        component: () => import(/* webpackChunkName:"homeIndex" */ '@/views/home/components/index.vue'),
        meta: {
          breadName: '首页',
          hiddenBread: true,
          showHeader: true,
        }
      },
      // 资源搜索
      {
        path: '/home/search',
        component: () => import(/* webpackChunkName:"search" */ '@/views/search/search.vue'),
        meta: {
          breadName: '资源搜索',
          breadNumber: 2,
          showHeader: true,
        }
      },
      //微课资源
      {
        path: '/home/cousrseResources',
        component: () => import(/* webpackChunkName:"cousrseResources" */ '@/views/courseResources/courseResources.vue'),
        meta: {
          breadName: '微课资源',
          breadNumber: 2,
          showHeader: true,
          keepAlive: true
        }
      },
      // 微课资源详情
      {
        path: '/home/cousrseResources/details',
        component: () => import(/* webpackChunkName:"CRdetails" */  '@/views/courseResources/courseResourcesDetails/courseResourcesDetails.vue'),
        meta: {
          breadName: '资源详情',
          breadNumber: 3,
          showHeader: true,
        }
      },
      // 教学文档
      {
        path: '/home/documents',
        component: () => import(/* webpackChunkName:"documents" */  '@/views/documents/documents.vue'),
        meta: {
          breadName: '教学文档',
          breadNumber: 2,
          showHeader: true,
          keepAlive: true
        }
      },
      // 教学文档详情
      {
        path: '/home/documents/details',
        component: () => import(/* webpackChunkName:"documentsDetails" */  '@/views/documents/documentDetail.vue'),
        meta: {
          breadName: '资源详情',
          breadNumber: 3,
          showHeader: true,
        }
      },
      //研修成果
      {
        path: '/home/achievements',
        component: () => import(/* webpackChunkName:"achievements" */ '@/views/achievements/achievements.vue'),
        meta: {
          breadName: '研修成果',
          breadNumber: 2,
          showHeader: true,
          keepAlive: true
        }
      },
      // 研修成果详情
      {
        path: '/home/achievements/details',
        component: () => import(/* webpackChunkName:"achievementsDetails" */  '@/views/achievements/achievementDetail.vue'),
        meta: {
          breadName: '资源详情',
          breadNumber: 3,
          showHeader: true,
        }
      },

      //上传文档
      {
        path: '/home/uploadDoc',
        component: () => import(/* webpackChunkName:"uploadDoc" */ '@/views/upload/uploadDoc.vue'),
        meta: {
          breadName: '上传文档',
          breadNumber: 2,
          showHeader: true,
        }
      },
      //上传视频
      {
        path: '/home/uploadVideo',
        component: () => import(/* webpackChunkName:"uploadVideo" */ '@/views/upload/uploadVideo.vue'),
        meta: {
          breadName: '上传视频',
          breadNumber: 2,
          showHeader: true,
        }
      },


    ]
  },
  // 精品课堂
  {
    path: '/pcourse',
    component: () => import(/* webpackChunkName:"personSpace" */ '@/views/pcourse/index.vue'),
    redirect: '/pcourse/index',
    meta: {
      hiddenBread: true,
    },
    children:[
      // 精品课堂首页
      {
        path:'/pcourse/index',
        component: () => import('@/views/pcourse/home/index.vue'),
        // hiddenBread: true,
        // showHeader: true,
      },
      {
        path:'/pcourse/topic',
        component: () => import('@/views/pcourse/topic/index.vue')
      },
      {
        path:'/pcourse/allcourse',
        component: () => import('@/views/pcourse/allcourse/index.vue')
      },
      {
        path:'/pcourse/courseDetail',
        component: () => import('@/views/pcourse/details/courseDetail.vue')
      },
      {
        path:'/pcourse/topicDetail',
        component: () => import('@/views/pcourse/details/topicDetail.vue')
      }
    ]

  },
  // 个人空间
  {
    path: '/personSpace',
    component: () => import(/* webpackChunkName:"personSpace" */ '@/views/personSpace/personSpace.vue'),
    redirect: '/personSpace/index',
    meta: {
      breadName: '个人空间',
      hiddenBread: true,
      showHeader: true,
     
    },
    children:[
      // 个人空间默认页面
      {
        path:'/personSpace/index',
        component: () => import('@/views/personSpace/index/index.vue'),
        hiddenBread: true,
        showHeader: true,
      },
      // 学时证明
      {
        path:'/personSpace/proof',
        component: () => import('@/views/personSpace/proof/index.vue'),
        redirect: '/personSpace/proof/proof',
        hiddenBread: true,
        showHeader: true,
        children: [
          // 
          {
            path:'/personSpace/proof/proof',
            component: () => import('@/views/personSpace/proof/proof.vue')
          },
          // 学时使用明细列表
          {
            path:'/personSpace/proof/detail',
            component: () => import('@/views/personSpace/proof/detail.vue')
          },
          //学习记录列表
          {
            path:'/personSpace/proof/studyList',
            component: () => import('@/views/personSpace/proof/studyList.vue')
          },
        ]
      },
      // 我的课程
      {
        path:'/personSpace/course',
        component: () => import('@/views/personSpace/course/index.vue'),
        redirect: '/personSpace/course/course',
        hiddenBread: true,
        showHeader: true,
        children: [
          //精品课程
          {
            path:'/personSpace/course/course',
            component: () => import('@/views/personSpace/course/course.vue')
          },
          // 专题
          {
            path:'/personSpace/course/topic',
            component: () => import('@/views/personSpace/course/topic.vue')
          },
          //录播回放
          {
            path:'/personSpace/course/playback',
            component: () => import('@/views/personSpace/course/playback.vue')
          },
        ]
      },
      // 我的资源
      {
        path:'/personSpace/resource',
        component: () => import('@/views/personSpace/resource/resource.vue'),
        hiddenBread: true,
        showHeader: true,
      },
      // 安全认证
      {
        path:'/personSpace/verify',
        component: () => import('@/views/personSpace/verify/verify.vue'),
        hiddenBread: true,
        showHeader: true,
      },
      // 我的钱包
      {
        path:'/personSpace/account',
        component: () => import('@/views/personSpace/account/account.vue'),
        redirect:'/personSpace/account/income',
        hiddenBread: true,
        showHeader: true,
        children:[
          // 收入记录
          {
            path:'/personSpace/account/income',
            component: () => import('@/views/personSpace/account/income/index.vue'),
            redirect:'/personSpace/account/income/income',
            children:[
              // 收入记录默认页面
              {
                path:'/personSpace/account/income/income',
                component: () => import('@/views/personSpace/account/income/income.vue'),
              },
              // 提现记录
              {
                path:'/personSpace/account/income/withdrawalRecords',
                component: () => import('@/views/personSpace/account/income/withdrawalRecords.vue'),
              },
              // 去提现
              {
                path:'/personSpace/account/income/withdrawal',
                component: () => import('@/views/personSpace/account/income/withdrawal.vue'),
              },
              // 税后收入 
              {
                path:'/personSpace/account/income/aftertaxincome',
                component: () => import('@/views/personSpace/account/income/afterTaxIncome.vue'),
              },
            ]
          },
          // 支出记录
          {
            path:'/personSpace/account/expenditure',
            component: () => import('@/views/personSpace/account/expenditure/index.vue'),
            redirect:'/personSpace/account/expenditure/expenditure',
            children:[
              //支出记录默认页面
              {
                path:'/personSpace/account/expenditure/expenditure',
                component: () => import('@/views/personSpace/account/expenditure/expenditure.vue'),
              },
              // 开票记录
              {
                path:'/personSpace/account/expenditure/invoicerecords',
                component: () => import('@/views/personSpace/account/expenditure/invoiceRecords.vue'),
              },
       
            ]
          }
        ]
      },
      // 我的消息
      {
        path:'/personSpace/message',
        component: () => import('@/views/personSpace/message/message.vue'),
      }
    ]
  },

  // 支付界面
  {
    path: '/pay',
    component: () => import(/* webpackChunkName:"pay" */ '@/views/pay/pay.vue'),
  },
  // 开发票界面
  {
    path:'/invoicing',
    component: () => import('@/views/personSpace/account/expenditure/invoicing.vue'),
  },


  {
    path: '/error/404',
    name: '404',
    component: () => import(/* webpackChunkName:"404" */ '@/views/error/404.vue'),
    meta: {
      hiddenBread: true,
      showHeader: false,
    }
  },
  {
    path: '/error/500',
    name: '500',
    component: () => import(/* webpackChunkName:"500" */ '@/views/error/500.vue'),
    meta: {
      hiddenBread: true,
      showHeader: false,
    }
  },
  {
    path: '/error/502',
    name: '502',
    component: () => import(/* webpackChunkName:"502" */ '@/views/error/502.vue'),
    meta: {
      hiddenBread: true,
      showHeader: false,
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  },
})

// 第一个 beforeEach 守卫：设置页面标题
router.beforeEach((to, from, next) => {

  

  if (to.fullPath.includes('/pcourse')) {
    document.title = '精品课堂'
  } else{
     document.title = '资源库'
  }
  next();
})

router.beforeEach(async (to, from) => {
  if (to.query.token) {
    await autoZykLogin({token: to.query.token}).then(async res1 => {
      const homeStore = useHomeStore()
      // 新打开资源库的时候showScrollHeader为true解决
      homeStore.showScrollHeader = false
      // 登录失效校验
      async function isLoginorNotM () {
        const res = await isLoginorNot()
        if (res.code == 0) {
          if (res.data) {
            //已登录 获取用户信息
            homeStore.getUserInfo('check')
          } else {
            //未登录 清除相关信息
            homeStore.quitClearData()
            // 如果是已在其他项目中退出,且本身是在个人空间/上传中刷新
            if (to.path == "/personSpace" || to.path.includes("/upload")) {
              // router.push('/home/index')
              return { path: '/home/index' }
            }
          }
        }
      }
      const res = await isLoginorNotM()
      return res
    })
  }else{
      const homeStore = useHomeStore()
      // 新打开资源库的时候showScrollHeader为true解决
      homeStore.showScrollHeader = false
      // 登录失效校验
      async function isLoginorNotM () {
        const res = await isLoginorNot()
        if (res.code == 0) {
          if (res.data) {
            //已登录 获取用户信息
            homeStore.getUserInfo('check')
          } else {
            //未登录 清除相关信息
            homeStore.quitClearData()
            // 如果是已在其他项目中退出,且本身是在个人空间/上传中刷新
            if (to.path == "/personSpace" || to.path.includes("/upload")) {
              // router.push('/home/index')
              return { path: '/home/index' }
            }
          }
        }
      }
      const res = await isLoginorNotM()
      return res
  }

})

export default router
